/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgencyContactDto } from '../../models/agency-contact-dto';

export interface ApiAgencycontactPut$Params {
  'api-version'?: string;
      body?: AgencyContactDto
}

export function apiAgencycontactPut(http: HttpClient, rootUrl: string, params?: ApiAgencycontactPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAgencycontactPut.PATH, 'put');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiAgencycontactPut.PATH = '/api/agencycontact';
